import Extension from "../base/extension";
import Stencil from "../stencil";

class Blog extends Extension {
  /**
   * @type {HTMLElement}
   */
  container;

  /**
   * ID of the section, so we know what section to request via fetch
   * @type {String}
   */
  sectionId;

  constructor(name) {
    super(name);
  }

  /**
   * Initialisation
   */
  init() {
    if(!Stencil.isBlogPage()) return;

    this.container = document.querySelector("#blog-container");
    if(!this.container){
      console.error(this.logPrefix, "No container found");
      return;
    }
    
    this.sectionId = this.container.dataset.sectionId;

    this.setupEventListeners();
    window.addEventListener('popstate', this.onHistoryChange.bind(this));
  }

  /**
   * Setup event listeners
   */
  setupEventListeners() {
    let filterButtons = this.container.querySelectorAll(".filter");
    filterButtons.forEach(filterButton => {
      filterButton.addEventListener("click", this.onLoadMoreClick.bind(this));
    });
  }

  /**
   * Reload the page if the user clicks 'back' in the browser
   * @param {PopStateEvent} event 
   */
  onHistoryChange(event) {
    this.renderPage(window.location.href, event, false);
  }

  /**
   * Render the section
   * @param {String} url The URL to load (tag filters)
   * @param {Event} event The original trigger event
   * @param {Boolean} updateURL Whether to update the URL with the new URL
   */
  renderPage(url, event, updateURL = true) {
    document.getElementById('results-loading').classList.remove('d-none');
    const sectionedUrl = `${url}${url.includes("?") ? "&" : "?"}section_id=${this.sectionId}`;
    this.renderSectionFromFetch(sectionedUrl, event);

    if (updateURL) {
      this.updateURL(url);
    }
  }

  /**
   * Fetch the section and re-render
   * @param {String} url URL to fetch and render 
   */
  renderSectionFromFetch(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        let parsedHtml = new DOMParser().parseFromString(html, 'text/html');
        document.getElementById("blog-container").innerHTML = parsedHtml.getElementById("blog-container").innerHTML;
        this.setupEventListeners();
        document.getElementById('results-loading').classList.add('d-none');
      });
  }

  /**
   * Start the process of loading in new cards
   * @param {Event} event The initiating event
   */
  onLoadMoreClick(event) {
    event.preventDefault();
    this.renderPage(event.currentTarget.href);
  }

  /**
   * Update the URL hash with new parameters
   * @param {String} url 
   */
  updateURL(url) {
    history.pushState({}, '', url);
  }
}

export default Blog;